import { put, takeLatest, all, fork } from 'redux-saga/effects'
import { requestActions } from 'state/request'
import { success, failure } from 'utilities/actions'
import * as actions from './actions'
import {
  API_URL,
  GRANTED_ORGANISATIONS_ENDPOINT
} from 'qap/constants'

export function* fetchGrantedOrganisations(action: any): Generator<any, any, any> {
  const { query } = action
  yield put({
    type: requestActions.AUTHED_REQUEST,
    method: 'GET',
    url: `${API_URL}/${GRANTED_ORGANISATIONS_ENDPOINT}?query=${encodeURIComponent(query)}`,
    successAction: success(actions.API_GRANTED_ORGANISATIONS_INDEX),
    failureAction: failure(actions.API_GRANTED_ORGANISATIONS_INDEX)
  })
}

function* watchFetchGrantedOrganisations(): Generator<any, any, any> {
  yield takeLatest([
    actions.API_GRANTED_ORGANISATIONS_INDEX
  ], fetchGrantedOrganisations)
}

export default function* grantedOrganisationsSagas(): Generator<any, any, any> {
  yield all([
    fork(watchFetchGrantedOrganisations)
  ])
}
